'use client';

import FortunePage1 from './FortunePage1';
import FortunePage2 from './FortunePage2';
import FortunePage3 from './FortunePage3';
import { useFortuneStep } from './useFortune';

const FortuneClient = () => {
  const [step] = useFortuneStep();

  if (step === 1) {
    return <FortunePage1 />;
  }

  if (step === 2) {
    return <FortunePage2 />;
  }

  if (step === 3) {
    return <FortunePage3 />;
  }

  return <></>;
};

export default FortuneClient;
